// extracted by mini-css-extract-plugin
export default {"name":"ShopPage_name__LdoMw"};